import TextInput from 'components/input/TextInput';
import Error from 'components/label/Error';

export default ({
  requiredFirstName,
  requiredLastName,
  errorName,
  firstName,
  lastName,
  onChangeFirstName,
  onChangeLastName,
  submitAttempted,
  centered = true,
  showErrorMessage = true,
  disabled,
  autoTitleCase
}) => (
  <>
    <div className={`columns ${centered ? 'is-centered' : ''}`}>
      <div className="column is-narrow first-text-box">
        <TextInput
          placeholder="First"
          onChange={onChangeFirstName}
          error={requiredFirstName && submitAttempted}
          // Adding the || '' makes sure field always counts as controlled so react doesn't complain
          value={firstName || ''}
          disabled={disabled}
          autoTitleCase={autoTitleCase}
          autocomplete="given-name"
        />
      </div>
      <div className="column is-narrow second-text-box">
        <TextInput
          placeholder="Last"
          onChange={onChangeLastName}
          error={requiredLastName && submitAttempted}
          value={lastName || ''}
          disabled={disabled}
          autoTitleCase={autoTitleCase}
          autocomplete="family-name"
        />
      </div>
    </div>
    {showErrorMessage ? <Error submitAttempted={submitAttempted} error={errorName} /> : ''}
    <style jsx>{`
      .first-text-box {
        margin-right: 23px;
      }

      .text-input {
        width: 240px;
        font-size: 18px;
      }

      @media all and (max-width: 768px) {
        .text-input {
          width: 100%;
          font-size: 16px;
        }

        .first-text-box {
          margin-right: auto;
        }

        .second-text-box {
          margin-top: 13px;
        }
      }
    `}</style>
  </>
);
